import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'screenList.title', 'defaultMessage': 'Screen list'}
});

interface ScreenListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class ScreenList extends React.Component<ScreenListProps> {

    typeName = 'screens';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const {screens} = this.props.user.organisation.channel;
        const list = screens;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <div>
                    <PagingGrid
                        columns={['channelEntityDef.entityDef.name', 'screenDef.name', 'operation', 'subOperation']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping}
                    />
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ScreenList), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name,
                        },
                        organisation_id,
                        screens(first: $first, after: $after, before: $before, last: $last) {
                            edges {
                                node {
                                    id,
                                    operation,
                                    organisation_id,
                                    channelEntityDef {
                                        id,
                                        entityDef {
                                            id,
                                            name
                                        }
                                    },
                                    channel_id,
                                    subOperation,
                                    screenDef {
                                        id,
                                        name
                                    }
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        }
                    }
                }
            }
        `,
    },
});
